import { LayerGroup, Marker, Polyline } from "react-leaflet";
import { ILocationWindRoseMarkerProps } from "./interfaces";
import "leaflet-geometryutil";
import L from "leaflet"
import { getOrderGeographicalDirection } from "utils/helpers";

export const LocationWindRoseMarker: React.FC<ILocationWindRoseMarkerProps> = (
  props: ILocationWindRoseMarkerProps
)=> {
  const point = L.latLng(props.markerData.latitude, props.markerData.longitude);

  const directions = [];
  for (let i = 22.5; i <= 360; i += 45) {
    const destination = L.GeometryUtil.destination(point, i, 1000000);
    directions.push(
      <Polyline
        key={`wind-rose-polyline-${i}`}
        positions={[point, destination]}
        color="gray"
        weight={2}
        opacity={0.5}
        dashArray="5, 5"
        dashOffset="10"
      />
    );

    const direction = getOrderGeographicalDirection(i - 22.5);
    const directionMarkerPosition = (L as any).GeometryUtil.destination(point, i - 22.5, 15000);
    directions.push(
      <Marker
        key={`wind-rose-marker-${i}`}
        position={directionMarkerPosition}
        icon={L.divIcon({
          className: "map-marker-direction",
          html: direction,
          iconSize: [50, 20],
          iconAnchor: [25, 10],
        })}
      />
    );
  }

  return <LayerGroup>{directions}</LayerGroup>;
};